import request from '../utils/request'

export function shopinfoGet() {
  return request({
    url: '/shop/info/get',
    method: 'post',
  })
}
